export default __webpack_public_path__ + "locales/profile.bua.json";